import React from 'react';
import TableHeader from './tableHeader';
import TableFoot from './tableFoot';
import TableBody from './tableBody';

const Table = ({ columns, data, message }) => {
  // console.log(message);
  return (
    <div className="card mb-3">
      <div className="card-header">
        <i className="fas fa-table" />
        {message}
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table
            className="table table-bordered"
            id="dataTable"
            width="100%"
            cellSpacing="0"
          >
            <TableHeader columns={columns} />
            <TableBody columns={columns} data={data} />
            <TableFoot columns={columns} />
          </table>
        </div>
      </div>
      <div className="card-footer small text-muted">
        Updated on {new Date(Date.now()).toGMTString()}
      </div>
    </div>
  );
};

export default Table;
